import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router/index.js'
import '@/assets/css/global.css'
import VueClipboard from 'vue-clipboard2';
// import '@/theme/index.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from '@/utils/request.js'
import * as customFilter from '@/js/momen.js'
import errImg from '@/assets/login.png'
import { getaway } from './utils/getawayModule'
import store from './store'
import { Message } from 'element-ui'
import {baseURL} from "@/utils/getawayModule";
// eslint-disable-next-line no-unused-vars
import preventReClick from '@/utils/plugins.js'
import './plugins'
//管理meta
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(VueClipboard)


Vue.prototype.imgUrlFormate = function (md5){
  return `${baseURL.userApi}/file/${md5}/download`;
}


Vue.prototype.axios = axios
Vue.prototype.message = Message

Vue.prototype.getaway = {
  user: getaway.user,
  business: getaway.business
}
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
Array.prototype.remove = function(val) {
  let index = this.indexOf(val)
  if (index > -1) {
    this.splice(index, 1)
  }
}


Vue.config.productionTip = false
// 全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false
// element 全局配置
Vue.use(ElementUI)

Vue.directive('err-img', {
  inserted: function(el) {
    el.onerror = function() {
      el.src = errImg
    }
  }
})

// 导出的是对象，可以直接通过key和value来获得过滤器的名和过滤器的方法
Object.keys(customFilter).forEach(key => {
  Vue.filter(key, customFilter[key])
})
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

